"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.grade.title': 'Aggiorna Account',
    'user.grade.free': 'Gratuito',
    'user.grade.basic': 'Base',
    'user.grade.pro': 'Pro',
    'user.grade.ultra': 'Ultra',
};
